var map = {
	"./404.png": 9411,
	"./Close.png": 2559,
	"./Expired.png": 5208,
	"./H5-Spay.png": 8422,
	"./Plate.png": 8263,
	"./boost.png": 6922,
	"./cash-1.png": 7480,
	"./cash.png": 1002,
	"./delivery.png": 5307,
	"./dine-in-table.png": 26,
	"./dine-in.png": 4681,
	"./exampleLogo.png": 560,
	"./imageNotFound.png": 3265,
	"./landingBackground.png": 4270,
	"./locationMarker.png": 3284,
	"./logo.png": 2806,
	"./logoText.png": 3667,
	"./marker.png": 2333,
	"./notFound.png": 7018,
	"./order.png": 2691,
	"./outletBg.png": 3677,
	"./product.png": 4134,
	"./productBg.png": 4827,
	"./rafiki.png": 7483,
	"./scanner.png": 6761,
	"./self-pickup-time.png": 8624,
	"./self-pickup.png": 4076,
	"./store.png": 840,
	"./store2.png": 2360,
	"./store3.png": 225,
	"./storeBg.png": 4597,
	"./storeLogo.png": 7337,
	"./take-away.png": 9235
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4504;